<template>
  <el-form-item label="Операторы" prop="operators">
    <el-select
      :value="value"
      multiple
      filterable
      collapse-tags
      :multiple-limit="maxOperators"
      :loading="loading"
      placeholder="Начните вводить название оператора"
      style="width: 100%"
      size="small"
      @input="$emit('input', $event)"
    >
      <el-option
        v-for="item in sortedOperators"
        :key="item.id_operator"
        :label="item.operator_name"
        :value="item.id_operator"
      >
        <span class="option__checkbox">
          <el-checkbox :value="value.includes(item.id_operator)" />
          {{ item.operator_name }}
        </span>
      </el-option>
    </el-select>
  </el-form-item>
</template>
<script>
import { ApiService } from "@/api";

const MAX_OPERATORS = 5;

export default {
  name: "OperatorsSelect",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      maxOperators: MAX_OPERATORS,
      loading: false,
      operators: [],
    };
  },
  computed: {
    // Выбранные операторы закрепляются в начале списка (ТЗ).
    sortedOperators() {
      const selected = this.operators.filter((item) => this.value.includes(item.id_operator));
      const rest = this.operators.filter((item) => !this.value.includes(item.id_operator));
      return [...selected, ...rest];
    },
  },
  created() {
    this.loading = true;
    ApiService.operators
      .getList({ search: "", page: 1, count: 100 })
      .then((res) => {
        this.operators = res.data.data;
      })
      .finally(() => {
        this.loading = false;
      });
  },
};
</script>
<style scoped>
.option__checkbox ::v-deep .el-checkbox {
  pointer-events: none;
  margin-right: 8px;
}
</style>
